import React, { FC } from 'react';

import { AbstractMenuItem, Props } from '../abstract-menu-item';

const PurchasingMenu: FC<Props> = props => {
  return (
    <AbstractMenuItem page="/purchasing" name="Purchasing" {...props} />
  );
};

export { PurchasingMenu };
